import type { ILogo } from "@src/types/AppTypes";
import React from "react";

const Logo: React.FC<ILogo> = React.memo(
  ({ id, src, style, alt, className, onClick, attributes, componentRef }) => {
    return (
      <img
        id={id}
        ref={componentRef}
        className={className + " " + "hover:cursor-pointer"}
        {...attributes}
        src={src}
        style={style}
        alt={alt}
        onClick={
          onClick
            ? onClick
            : () => {
                return;
              }
        }
      />
    );
  }
);

export default Logo;
